/** Client PO workflow status labels. */
export const ORDER_STATUS_LABEL = {
  draft: 'Draft',
  signature: 'Signature',
  invoicing: 'Invoicing',
  completed: 'Completed',
  executed: 'Executed',
  expired: 'Expired',
};

export function orderStatusLabel(status) {
  return ORDER_STATUS_LABEL[status] || status;
}
